import React from 'react';
import LeadForm from './LeadForm';
import { whatsappUrl } from './WhatsAppButton';

function Contact() {
  return (
    <div className="section contact-section reveal">
      <div className="content contact-layout">
        <div>
          <p className="eyebrow">Contact & Lead Forms</p>
          <h2>Let&apos;s improve herd performance together.</h2>
          <p>
            Connect with Zyvora Life Sciences 9 for product enquiries, distributor opportunities, bulk supply discussions, and cattle nutrition support.
          </p>
          <ul className="contact-list premium-list">
            <li><strong>Head Office:</strong> A108, Judge’s Cultural & Welfare Organisation, Greater Noida, Delhi NCR, Pin: 201310</li>
            <li><strong>GSTIN:</strong> 09AXTPS5184M1Z9</li>
            <li><strong>Phone:</strong> +91 9868510836, +91 7005032815</li>
            <li><strong>Email:</strong> sales@zyvoralifesciences.com</li>
          </ul>
          <a href={whatsappUrl} target="_blank" rel="noreferrer" className="btn gold">Start WhatsApp Inquiry</a>
        </div>

        <div className="form-stack">
          <div>
            <h3>General Inquiry Form</h3>
            <LeadForm formType="General Inquiry" submitLabel="Submit General Inquiry" />
          </div>
          <div>
            <h3>Distributor Inquiry Form</h3>
            <LeadForm formType="Distributor Inquiry" submitLabel="Submit Distributor Inquiry" />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Contact;
